import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import classNames from 'classnames'
import { injectIntl, FormattedMessage } from 'react-intl'
import HighlightedTextarea from './HighlightedTextarea'
import { charCountLimit } from './index'
import { checkIfEmpty } from '../../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import Loader from '../Loader'
import { updateEditDynamicDataState } from '../../actions/AspireEditDynamicData'
import { updateNewSamplesState } from '../../actions/AspireSamples'
import {
  fetchResumeGap,
  updateResumeGapState,
} from '../../actions/AspireResumeGap'
import { editModalAriaLabel } from '../Constants/AriaLabelText'
import SelectPlus from 'react-select-plus'
import ThreeDotsButton from './HelperComponents/ThreeDotsButton'
import SaveBtn from './HelperComponents/SaveBtn'


class Experience extends Component {


  constructor(props) {
    super(props)
    this.state = {
      selectedModule: 'samples',
      selectedSkill: '',
      selectedPresentCategory: '',
      focused: {
        title: false,
        company: false,
        from: false,
        to: false,
        text: false,
      },
      checkbox: {
        tense: false,
        narrative_voice: false,
        buzzwords: false,
        verb_overusage: false,
        action_oriented: false,
        specifics: false,
      },
      checkCurrent: false,
      data: {
        fromMonth: '',
        fromYear: '',
        toMonth: '',
        toYear: '',
      },
      iimmumbaiExampleIndex: 0,
    }
    this.placeholders = {
      title: this.props.intl.formatMessage({ id: "aspire.experience.placeholderTitle", defaultMessage: "Enter job title" }),
      company: this.props.intl.formatMessage({ id: "aspire.experience.placeholderCompany", defaultMessage: "Enter company" }),
      from: this.props.intl.formatMessage({ id: "aspire.experience.placeholderFrom", defaultMessage: "Enter start date" }),
      to: this.props.intl.formatMessage({ id: "aspire.experience.placeholderTo", defaultMessage: "Enter end date" }),
      text: this.props.intl.formatMessage({ id: "aspire.experience.placeholderText", defaultMessage: "Enter description" }),
    }
    this.months = {
      Jan: this.props.intl.formatMessage({ id: "aspire.experience.monthJanuary", defaultMessage: "January" }),
      Feb: this.props.intl.formatMessage({ id: "aspire.experience.monthFebruary", defaultMessage: "February" }),
      Mar: this.props.intl.formatMessage({ id: "aspire.experience.monthMarch", defaultMessage: "March" }),
      Apr: this.props.intl.formatMessage({ id: "aspire.experience.monthApril", defaultMessage: "April" }),
      May: this.props.intl.formatMessage({ id: "aspire.experience.monthMay", defaultMessage: "May" }),
      Jun: this.props.intl.formatMessage({ id: "aspire.experience.monthJune", defaultMessage: "June" }),
      Jul: this.props.intl.formatMessage({ id: "aspire.experience.monthJuly", defaultMessage: "July" }),
      Aug: this.props.intl.formatMessage({ id: "aspire.experience.monthAugust", defaultMessage: "August" }),
      Sep: this.props.intl.formatMessage({ id: "aspire.experience.monthSeptember", defaultMessage: "September" }),
      Oct: this.props.intl.formatMessage({ id: "aspire.experience.monthOctober", defaultMessage: "October" }),
      Nov: this.props.intl.formatMessage({ id: "aspire.experience.monthNovember", defaultMessage: "November" }),
      Dec: this.props.intl.formatMessage({ id: "aspire.experience.monthDecember", defaultMessage: "December" }),
    }
    this.allowedModulesList = [
      'skills',
      'content',
      'language',
      'impact',
      'samples',
      'rephrase_words',
    ]
    this.moduleIconsMapping = {
      skills: 'dist/images/edit-screens/skills-icon.svg',
      content: 'dist/images/edit-screens/content-icon.svg',
      language: 'dist/images/edit-screens/language-icon.svg',
      impact: 'dist/images/edit-screens/impact-icon.svg',
      samples: 'dist/images/edit-screens/samples-icon.svg',
      rephrase_words: 'dist/images/edit-screens/rephrase-words-icon.svg',
    }
    this.displayNameMapping = {
      skills: this.props.intl.formatMessage({ id: "aspire.experience.displayNameSkills", defaultMessage: "Skills" }),
      content: this.props.intl.formatMessage({ id: "aspire.experience.displayNameContent", defaultMessage: "Content" }),
      language: this.props.intl.formatMessage({ id: "aspire.experience.displayNameLanguage", defaultMessage: "Language" }),
      impact: this.props.intl.formatMessage({ id: "aspire.experience.displayNameImpact", defaultMessage: "Impact" }),
      samples: this.props.intl.formatMessage({ id: "aspire.experience.displayNameSamples", defaultMessage: "Samples" }),
      rephrase_words: this.props.intl.formatMessage({ id: "aspire.experience.displayNameWordUsage", defaultMessage: "Word Usage" }),
    }
    this.modulesPresent = []
    this.getFeedbackNav = this.getFeedbackNav.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.updateCheckboxState = this.updateCheckboxState.bind(this)
    this.handleUndoClick = this.handleUndoClick.bind(this)
    this.checkValidDate = this.checkValidDate.bind(this)
    this.highlightValues = this.highlightValues.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.sendTrackingDataDebounceUndo = _.debounce(sendTrackingData, 3000, true)
    this.descriptionCharsRemaining = charCountLimit['experience']['text']
    this.handleCloseButton = this.handleCloseButton.bind(this)
    this.setSelectedSkill = this.setSelectedSkill.bind(this)
    this.setSelectedPresentCategory = this.setSelectedPresentCategory.bind(this)
    this.loadLeftNav = this.loadLeftNav.bind(this)
  }

  UNSAFE_componentWillMount() {
    const {
      sectionWiseTextEditable,
      fetchResumeGap,
      currentIndex,
      fetchId,
      hasResume,
      newSubSection,
      feedback,
    } = this.props
    this.descriptionCharsRemaining =
      charCountLimit['experience']['text'] -
      sectionWiseTextEditable[currentIndex]['text'].length

    if (
      !_.isEmpty(sectionWiseTextEditable[currentIndex]['to']) &&
      sectionWiseTextEditable[currentIndex]['to'] == 'Present'
    ) {
      this.setState({ checkCurrent: true })
    }

    this.setInitialState()

    if (hasResume == 1) {
      if (newSubSection == true) {
        fetchResumeGap(fetchId, 'Experience', -1)
      } else {
        fetchResumeGap(fetchId, 'Experience', currentIndex)
      }
    }
    this.loadLeftNav(newSubSection, feedback)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { feedback, newSubSection } = nextProps

    this.loadLeftNav(newSubSection, feedback)
  }

  loadLeftNav(newSubSection, feedback) {
    if (newSubSection) {
      this.modulesPresentList = [
        'samples',
        'content',
        'skills',
        'language',
        'impact',
        'rephrase_words',
      ]
    } else {
      this.modulesPresentList = ['samples']
      if (
        !_.isUndefined(feedback['categories']) &&
        !_.isEmpty(feedback['categories']) &&
        feedback['categories'].hasOwnProperty('categories')
      ) {
        this.modulesPresentList.push('content')
      }
      if (
        !_.isUndefined(feedback['skills']) &&
        !_.isEmpty(feedback['skills'])
      ) {
        this.modulesPresentList.push('skills')
      }
      if (
        !_.isUndefined(feedback['language']) &&
        !_.isEmpty(feedback['language']) &&
        (feedback['language'].hasOwnProperty('tense') ||
          feedback['language'].hasOwnProperty('narrative_voice'))
      ) {
        this.modulesPresentList.push('language')
      }
      if (
        !_.isUndefined(feedback['impact']) &&
        !_.isEmpty(feedback['impact'])
      ) {
        this.modulesPresentList.push('impact')
      }
      if (
        !_.isUndefined(feedback['language']) &&
        !_.isEmpty(feedback['language']) &&
        (feedback['language'].hasOwnProperty('verb_overusage') ||
          feedback['language'].hasOwnProperty('buzzwords'))
      ) {
        this.modulesPresentList.push('rephrase_words')
      }
    }

    let isCurrentSelectedModulePresentInNewFeedback = _.indexOf(
      this.modulesPresentList,
      this.state.selectedModule
    )

    if (isCurrentSelectedModulePresentInNewFeedback == -1) {
      this.setState({ selectedModule: 'samples' })
    }
  }

  setSelectedSkill(skill) {
    this.setState({ selectedSkill: skill })
  }

  setSelectedPresentCategory(category) {
    this.setState({ selectedPresentCategory: category })
  }

  handleModuleClick(module) {
    const { currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'module_click',
      currentSection: 'Experience',
      currentIndex: currentIndex,
      module: module,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.setState({ selectedModule: module })
  }

  getFeedbackNav() {
    const { feedback, intl } = this.props

    let links = _.map(
      this.modulesPresentList,
      function (module) {
        let isActive = false
        if (this.state.selectedModule == module) {
          isActive = true
        }
        let moduleDisplayName = this.displayNameMapping[module]
        let moduleIcon = this.moduleIconsMapping[module]

        return (
          <div key={module}>
            <a
              className={classNames('as-nav-list-item', { active: isActive })}
              tabIndex={0}
              href="javascript:void(0);"
              aria-label={editModalAriaLabel(intl)[module]}
              onClick={() => this.handleModuleClick(module)}>
              <div className="as-nav-list-item-icon">
                <img src={`${process.env.APP_BASE_URL + moduleIcon}`} alt="" />
              </div>
              <div className="as-nav-list-item-text">{moduleDisplayName}</div>
            </a>
          </div>
        )
      },
      this
    )

    return <div className="as-edit-feedback-nav as-shadow">{links}</div>
  }

  setInitialState() {
    let data = $.extend({}, this.state.data, this.getMonthAndYear())
    this.setState({ data: data })
  }

  handleDateChange(option) {
    let value = option.value
    let name = option.name
    if (!_.isUndefined(this.state.data[name])) {
      if (name.indexOf('from') !== -1) {
        name = 'from'
        value = `${
          option.name === 'fromMonth' ? value : this.state.data['fromMonth']
        } ${option.name === 'fromYear' ? value : this.state.data['fromYear']}`
      } else if (name.indexOf('to') !== -1) {
        name = 'to'
        value = `${
          option.name === 'toMonth' ? value : this.state.data['toMonth']
        } ${option.name === 'toYear' ? value : this.state.data['toYear']}`
      }
    }

    this.props.handleOnChangeData(
      'experience',
      this.props.currentIndex,
      name,
      value
    )
  }

  handleChange(e) {
    let value = e.target.value
    let name = e.target.name
    if (!_.isUndefined(this.state.data[name])) {
      if (name.indexOf('from') !== -1) {
        name = 'from'
        value = `${
          e.target.name === 'fromMonth' ? value : this.state.data['fromMonth']
        } ${e.target.name === 'fromYear' ? value : this.state.data['fromYear']}`
      } else if (name.indexOf('to') !== -1) {
        name = 'to'
        value = `${
          e.target.name === 'toMonth' ? value : this.state.data['toMonth']
        } ${e.target.name === 'toYear' ? value : this.state.data['toYear']}`
      }
    }

    this.props.handleOnChangeData(
      'experience',
      this.props.currentIndex,
      name,
      value
    )

    if (name == 'text') {
      let charsRemainingCount = -1
      if (
        charCountLimit.hasOwnProperty('experience') &&
        charCountLimit['experience'].hasOwnProperty('text')
      ) {
        charsRemainingCount =
          charCountLimit['experience']['text'] - value.length
      }
      this.descriptionCharsRemaining = charsRemainingCount
    }
  }

  handleUndoClick() {
    if (
      !_.isEmpty(
        this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
      ) &&
      this.props.sectionWiseTextEditable[this.props.currentIndex]['to'] ==
        'Present'
    ) {
      this.setState({ checkCurrent: true })
    }

    const { currentIndex, sectionWiseTextStatic } = this.props

    let jsonObjectForTracking = {
      eventLabel: 'undo_changes_btn',
      currentSection: 'Experience',
      currentIndex: currentIndex,
    }

    this.sendTrackingDataDebounceUndo(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.props.handleUndoData('experience', this.props.currentIndex)
    this.descriptionCharsRemaining =
      charCountLimit['experience']['text'] -
      sectionWiseTextStatic[currentIndex]['text'].length
  }

  handleCloseButton() {
    const {
      handleUndoData,
      currentIndex,
      hideEditModal,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
    } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'close_btn',
      currentSection: 'Experience',
      currentIndex: currentIndex,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    hideEditModal(
      'experience',
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic
    )
  }

  checkValidDate(current) {
    return current.isBefore(moment()) && current.isAfter(moment('DEC 1949'))
  }

  getMonthAndYear() {
    let fromArray =
      this.props.sectionWiseTextEditable[this.props.currentIndex]['from'].split(
        ' '
      )
    let toArray =
      this.props.sectionWiseTextEditable[this.props.currentIndex]['to'].split(
        ' '
      )

    // For present case
    if (
      !_.isEmpty(
        this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
      ) &&
      this.props.sectionWiseTextEditable[this.props.currentIndex]['to'] ==
        'Present'
    ) {
      toArray[0] = ''
      toArray[1] = ''
    }

    return {
      fromMonth: _.isUndefined(fromArray[0]) ? '' : fromArray[0].trim(),
      fromYear: _.isUndefined(fromArray[1]) ? '' : fromArray[1].trim(),
      toMonth: _.isUndefined(toArray[0]) ? '' : toArray[0].trim(),
      toYear: _.isUndefined(toArray[1]) ? '' : toArray[1].trim(),
    }
  }

  getSelectOptionsMonth(name) {
    return _.map(this.months, (fullName, idx) => {
      return { value: idx, label: fullName, name: name }
    })
  }

  getSelectOptionsYear(name) {
    let options = []
    let startYear = new Date().getFullYear() - 59

    for (let i = 59; i >= 0; i--) {
      let year = startYear + i
      options.push({ value: year.toString(), label: year, name: name })
    }
    return options
  }

  handleFromDateChange(date) {
    if (this.hasOwnProperty('handleOnChangeData')) {
      this.handleOnChangeData('experience', this.currentIndex, 'from', date)
    } else {
      this.props.handleOnChangeData(
        'experience',
        this.props.currentIndex,
        'from',
        date
      )
    }
  }

  handleToDateChange(date) {
    if (this.hasOwnProperty('handleOnChangeData')) {
      this.handleOnChangeData('experience', this.currentIndex, 'to', date)
    } else {
      this.props.handleOnChangeData(
        'experience',
        this.props.currentIndex,
        'to',
        date
      )
    }
  }

  handleCheckClick() {
    if (this.state.checkCurrent == false) {
      this.props.handleOnChangeData(
        'experience',
        this.props.currentIndex,
        'to',
        'Present'
      )
    } else {
      this.props.handleOnChangeData(
        'experience',
        this.props.currentIndex,
        'to',
        ''
      )
    }
    this.setState((prevState) => ({ checkCurrent: !prevState.checkCurrent }))
  }

  handleFocus(field, e) {
    e.preventDefault()
    const { unhighlightAll } = this.props
    unhighlightAll()
    let focused = this.state.focused
    for (let i in focused) {
      if (i == field) {
        focused[i] = true
      } else {
        focused[i] = false
      }
    }
    let checkbox = {
      tense: false,
      narrative_voice: false,
      buzzwords: false,
      verb_overusage: false,
      action_oriented: false,
      specifics: false,
    }
    this.setState({
      focused: focused,
      checkbox: checkbox,
      selectedSkill: '',
      selectedPresentCategory: '',
    })
    setTimeout(() => {
      if ($('.as-edit-input-field-wrapper').find('input').length != 0) {
        $('.as-edit-input-field-wrapper').find('input')[0].focus()
      }
    }, 100)
  }

  handleBlur(field) {
    let focused = this.state.focused
    focused[field] = false
    this.setState({ focused: focused })
  }

  highlightValues(input) {
    return this.props.highlightableDivWords
  }

  renderEntityText(entity) {
    const { savingChanges, intl } = this.props

    let fieldDisabled = false
    if (savingChanges) {
      fieldDisabled = true
    }

    if (this.state.focused[entity] == true) {
      // When the input field is in focus
      if (entity == 'title') {
        return (
          <input
            type="text"
            className=""
            name="title"
            value={
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'title'
              ]
            }
            aria-label={editModalAriaLabel(intl)['Experience']['input_title']}
            placeholder={this.placeholders['title']}
            onChange={(e) => this.handleChange(e)}
            onBlur={() => this.handleBlur('title')}
            disabled={fieldDisabled}
          />
        )
      } else if (entity == 'company') {
        return (
          <input
            type="text"
            className=""
            name="company"
            value={
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'company'
              ]
            }
            aria-label={editModalAriaLabel(intl)['Experience']['input_company']}
            placeholder={this.placeholders['company']}
            onChange={(e) => this.handleChange(e)}
            onBlur={() => this.handleBlur('company')}
            disabled={fieldDisabled}
          />
        )
      }
    } else {
      // When the input field is in static state
      if (entity == 'title') {
        return (
          <div
            className="experience-entity-title entity-text as-input-div hide-scrollbar"
            onMouseDown={(e) => this.handleFocus('title', e)}
            tabIndex={0}
            role="textbox"
            aria-label='Title'
            onFocus={(e) => this.handleFocus('title', e)}
            disabled={fieldDisabled}>
            {this.renderPlaceholder(
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'title'
              ],
              'title'
            )}
          </div>
        )
      } else if (entity == 'company') {
        return (
          <div
            className="experience-entity-company entity-text as-input-div hide-scrollbar"
            onMouseDown={(e) => this.handleFocus('company', e)}
            onFocus={(e) => this.handleFocus('company', e)}
            disabled={fieldDisabled}
            aria-label={'Company'}
            role="textbox"
            tabIndex={0}>
            {this.renderPlaceholder(
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'company'
              ],
              'company'
            )}
          </div>
        )
      }
    }

    if (entity == 'text') {
      return (
        <div className="edit-experience-description">
          <HighlightedTextarea
            label="Description"
            name="text"
            highlight={this.highlightValues}
            value={
              this.props.sectionWiseTextEditable[this.props.currentIndex][
                'text'
              ]
            }
            placeholder={this.placeholders['text']}
            onFocus={(e) => this.handleFocus('text', e)}
            onBlur={() => this.handleBlur('text')}
            onChange={this.handleChange}
            disabled={fieldDisabled}
          />
          <span className="experience-chars-remain description">
            <span>
              {intl.formatMessage({
                id: "aspire.experience.descriptionLinkedinNote",
                defaultMessage: "The character count is maintained in accordance with LinkedIn guidelines"
              })}
            </span>
          </span>
          <span
            className="experience-chars-remain"
            tabIndex={0}
            aria-label={intl.formatMessage({
              id: "aspire.experience.characterRemaining",
              defaultMessage: "{count} character(s) remaining"
            }, { count: this.descriptionCharsRemaining })}>
            <span>
              {charCountLimit['experience']['text'] -
                this.descriptionCharsRemaining}
            </span>
            /{charCountLimit['experience']['text']}
          </span>
        </div>
      )
    } else if (entity == 'to') {
      if (this.state.checkCurrent == true) {
        let toPlaceholder = this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
        if (
          !_.isEmpty(
            this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
          ) &&
          this.props.sectionWiseTextEditable[this.props.currentIndex]['to'] ==
            'Present'
        ) {
          toPlaceholder = this.props.intl.formatMessage({ id: "aspire.experience.labelPresent", defaultMessage: "Present" })
        }
        return (
          <div
            key={entity}
            className="experience-entity-to entity-text as-input-div">
            {this.renderPlaceholder(
              toPlaceholder,
              'to'
            )}
          </div>
        )
      } else {
        return (
          <div className="row experience-date-select-row">
            <SelectPlus
              className="as-edit-select-field-right experience-to-month-select col-sm-6"
              closeOnSelect={true}
              name="toMonth"
              value={this.state.data.toMonth}
              searchable={false}
              valueKey="value"
              arrowRenderer={() => {
                return null
              }}
              clearable={false}
              tabSelectsValue={false}
              placeholder={intl.formatMessage({
                id: "aspire.experience.placeholderMonth",
                defaultMessage: "Month"
              })}
              aria-label={editModalAriaLabel(intl)['Experience']['to_month']}
              options={this.getSelectOptionsMonth('toMonth')}
              onFocus={(e) => this.handleFocus('to', e)}
              onBlur={() => this.handleBlur('to')}
              onChange={this.handleDateChange}
            />
            <SelectPlus
              className="as-edit-select-field-right experience-to-year-select col-sm-6"
              closeOnSelect={true}
              name="toYear"
              value={this.state.data.toYear}
              searchable={false}
              valueKey="value"
              arrowRenderer={() => {
                return null
              }}
              clearable={false}
              tabSelectsValue={false}
              placeholder={intl.formatMessage({
                id: "aspire.experience.placeholderYear",
                defaultMessage: "Year"
              })}
              aria-label={editModalAriaLabel(intl)['Experience']['to_year']}
              options={this.getSelectOptionsYear('toYear')}
              onFocus={(e) => this.handleFocus('to', e)}
              onBlur={() => this.handleBlur('to')}
              onChange={this.handleDateChange}
            />
            <div className="clearfix" />
          </div>
        )
      }
    } else if (entity == 'from') {
      return (
        <div className="row experience-date-select-row">
          <SelectPlus
            className="as-edit-select-field-left col-sm-6"
            closeOnSelect={true}
            name="fromMonth"
            value={this.state.data.fromMonth}
            searchable={false}
            valueKey="value"
            arrowRenderer={() => {
              return null
            }}
            clearable={false}
            tabSelectsValue={false}
            placeholder={intl.formatMessage({
              id: "aspire.experience.placeholderMonth",
              defaultMessage: "Month"
            })}
            aria-label={editModalAriaLabel(intl)['Experience']['from_month']}
            disabled={fieldDisabled}
            options={this.getSelectOptionsMonth('fromMonth')}
            onFocus={(e) => this.handleFocus('to', e)}
            onBlur={() => this.handleBlur('to')}
            onChange={this.handleDateChange}
          />
          <SelectPlus
            className="as-edit-select-field-right experience-from-year-select col-sm-6"
            closeOnSelect={true}
            name="fromYear"
            value={this.state.data.fromYear}
            searchable={false}
            valueKey="value"
            arrowRenderer={() => {
              return null
            }}
            clearable={false}
            tabSelectsValue={false}
            placeholder={intl.formatMessage({
              id: "aspire.experience.placeholderYear",
              defaultMessage: "Year"
            })}
            aria-label={editModalAriaLabel(intl)['Experience']['from_year']}
            disabled={fieldDisabled}
            options={this.getSelectOptionsYear('fromYear')}
            onFocus={(e) => this.handleFocus('from', e)}
            onBlur={() => this.handleBlur('from')}
            onChange={this.handleDateChange}
          />
          <div className="clearfix" />
        </div>
      )
    }
  }


  todayDate() {
    let a = new Date().toString().split(' ')
    return a[1] + ' ' + a[3]
  }

  renderPlaceholder(text, field) {
    if (!_.isEmpty(text)) {
      let text2 = text.split('\n'),
        text3 = []
      for (let i in text2) {
        if (!text2[i].match(/[a-z0-9]/i)) {
          text3.push(<br />)
        } else {
          text3.push(<div key={field + '-' + i}>{text2[i]}</div>)
        }
      }
      return text3
    }
    return (
      <span key={field} className="placeholder-color">
        {this.placeholders[field]}
      </span>
    )
  }

  updateCheckboxState(checkbox) {
    this.setState({ checkbox: checkbox })
  }

  getLabel(field, heading, emptyCondition) {
    const { savingChanges, intl } = this.props
    let colorClass = null
    let fieldDisabled = false
    if (_.isEmpty(emptyCondition)) {
      colorClass = 'as-edit-input-field-label'
    } else if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
      fieldDisabled = false
    } else if (this.state.focused[field]) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    if (field == 'to') {
      return (
        <span
          style={{ width: '100%' }}>
          <label className={colorClass}>
            {heading} <span className="text-red">*</span>
          </label>
          <span className="is-current-checkbox-wrapper">
            <input
              aria-checked={this.state.checkCurrent}
              aria-label={
                editModalAriaLabel(intl)['Experience']['is_current'][
                  this.state.checkCurrent
                ]
              }
              className="is-current-checkbox"
              onChange={() => this.handleCheckClick()}
              onFocus={(e) => this.handleFocus('to', e)}
              onBlur={() => this.handleBlur('to')}
              type="checkbox"
              checked={this.state.checkCurrent}
              disabled={fieldDisabled}
            />
            <span className="is-current-checkbox-text">
              {intl.formatMessage({
                id: "aspire.experience.labelPresent",
                defaultMessage: "Present"
              })}
            </span>
          </span>
        </span>
      )
    } else if (field == 'from') {
      return (
        <span
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['Experience']['from']}>
          <label className={colorClass}>
            {heading} <span className="text-red">*</span>
          </label>
        </span>
      )
    }
    return (
      <label className={colorClass}>
        {heading} <span className="text-red">*</span>
      </label>
    )
  }

  getSimpleLabel(field, heading) {
    const { savingChanges, intl } = this.props
    let colorClass = null
    if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    } else if (this.state.focused[field]) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return <label className={colorClass}>{heading} </label>
  }

  getStaticSuggestion() {
    const { intl, user } = this.props;
    const { community } = user || {};
    if ( community === 'mofo' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.experience.writingTipsHeadlineMofo" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.experience.writingTipsTextMofo" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.experience.tipsToGetStartedHeadlineMofo" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.experience.tipsToGetStartedTextMofo" }),
      };
    }
    if ( community === 'iimmumbai' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.experience.writingTipsHeadlineIIMMumbai" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.experience.writingTipsTextIIMMumbai" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.experience.tipsToGetStartedHeadlineIIMMumbai" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.experience.tipsToGetStartedTextIIMMumbai" }),
        examples: [
          { headline: intl.formatMessage({ id: "staticSuggestion.experience.exampleHeadline1IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.experience.exampleText1IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.experience.exampleHeadline2IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.experience.exampleText2IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.experience.exampleHeadline3IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.experience.exampleText3IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.experience.exampleHeadline4IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.experience.exampleText4IIMMumbai" }) },
        ],
      };
    }
    return {
      writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.experience.writingTipsHeadline" }),
      writingTipsText: intl.formatMessage({ id: "staticSuggestion.experience.writingTipsText" }),
      tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.experience.tipsToGetStartedHeadline" }),
      tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.experience.tipsToGetStartedText" }),
    };
  }

  render() {
    const {
      savingChanges,
      currentIndex,
      newSubSection,
      hideEditModal,
      sectionWiseText,
      sectionWiseTextStatic,
      sectionWiseTextEditable,
      highlightEntityText,
      unhighlightAll,
      feedback,
      handleSaveChanges,
      handleUndoData,
      fetchId,
      addNewSection,
      showConfirmDeleteModal,
      showLogModal,
      intl,
      isRightNavToggle,
    } = this.props

    let undoButton = null
    let saveDisabled = true
    if (
      !(
        JSON.stringify(sectionWiseTextEditable[currentIndex]) ===
          JSON.stringify(sectionWiseTextStatic[currentIndex]) || savingChanges
      )
    ) {
      saveDisabled = false
      undoButton = (
        <button
          aria-label={editModalAriaLabel(intl)['reset']}
          className="btn btn-undo-changes"
          onClick={this.handleUndoClick}
          onMouseDown={this.handleUndoClick}>
          {intl.formatMessage({
            id: "aspire.experience.buttonReset",
            defaultMessage: "Reset"
          })}
        </button>
      )
    }
    let saveButton = (
      <SaveBtn
        savingChanges={savingChanges}
        saveDisabled={saveDisabled}
        handleSaveChanges={handleSaveChanges}
        intl={intl}
      />
    )

    let editOrAdd =
      !_.isUndefined(currentIndex) &&
      _.isString(currentIndex) &&
      currentIndex.substr(-4) === '_new'
        ? 'Add'
        : 'Edit'

    // calculation for focused state and black overlay
    let blackOverlayClass = ''
    let editFocusedClass = ''

    let isAnyFieldFocused = false
    for (let index in this.state.focused) {
      if (this.state.focused[index]) {
        isAnyFieldFocused = true
        break
      }
    }

    if (savingChanges) {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
    } else if (isAnyFieldFocused) {
      blackOverlayClass = 'as-edit-overlay-none as-edit-overlay-black'
      editFocusedClass = 'as-edit-focused-none as-edit-focused-black'
    } else {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
    }
    let threeDotsBtn = (
      <ThreeDotsButton
        addNewSection={addNewSection}
        showConfirmDeleteModal={showConfirmDeleteModal}
        showLogModal={showLogModal}
        section="Experience"
      />
    )

    if (newSubSection) {
      undoButton = null
      threeDotsBtn = null
    }

    const experienceTips = this.getStaticSuggestion();

    return (
      <div className="as-edit-wrapper scroll-hidden">
        <Loader sectionName="Experience" />
        <div className="as-edit-close-div">
          <a
            href="javascript:void(0);"
            aria-label={editModalAriaLabel(intl)['close']}
            onClick={this.handleCloseButton}
            className="icon-cross as-edit-close-btn modal-close-button"
            style={!isRightNavToggle ? { right: '17%' } : {}}
          />
        </div>
        <div className="as-edit-heading-wrapper">
          <div className="as-edit-heading" role="heading" aria-level="3">
            {intl.formatMessage({
              id: "aspire.experience.headingExperience",
              defaultMessage: "Experience"
            })}
          </div>
          <div className="as-edit-actions-div">
            <div className="as-edit-action-undo">{undoButton}</div>
            <div className="as-edit-action-save">{saveButton}</div>
            {threeDotsBtn}
          </div>
        </div>
        <div className="as-edit-container as-experience-container">
          <div className={editFocusedClass}>
            <div className="row as-edit-inputs-row">
              <div className="col-sm-6 as-edit-inputs-col">
                {this.getLabel(
                  'title',
                  intl.formatMessage({ id: "aspire.experience.labelJobTitle", defaultMessage: "Job Title" }),
                  sectionWiseTextEditable[currentIndex]['title']
                )}
                <div
                  className="as-edit-input-field-wrapper"
                  style={{ paddingRight: '10px' }}>
                  {this.renderEntityText('title')}
                </div>
              </div>
              <div className="col-sm-6 as-edit-inputs-col">
                {this.getLabel(
                  'company',
                  intl.formatMessage({ id: "aspire.experience.labelCompany", defaultMessage: "Company" }),
                  sectionWiseTextEditable[currentIndex]['company']
                )}
                <div className="as-edit-input-field-wrapper">
                  {this.renderEntityText('company')}
                </div>
              </div>
              <div className="col-sm-6 as-edit-inputs-col">
                {this.getLabel(
                  'from',
                  intl.formatMessage({ id: "aspire.experience.labelFrom", defaultMessage: "From" }),
                  sectionWiseTextEditable[currentIndex]['from']
                )}
                <div className="as-edit-select-field">
                  {this.renderEntityText('from')}
                </div>
              </div>
              <div className="col-sm-6 as-edit-inputs-col">
                {this.getLabel(
                  'to',
                  intl.formatMessage({ id: "aspire.experience.labelTo", defaultMessage: "To" }),
                  sectionWiseTextEditable[currentIndex]['to']
                )}
                <div className="as-edit-select-field">
                  {this.renderEntityText('to')}
                </div>
              </div>
              <div className="col-sm-12 as-edit-inputs-col">
                {this.getSimpleLabel(
                  'text',
                  intl.formatMessage({ id: "aspire.experience.labelDescription", defaultMessage: "Description" }),
                )}
                {this.renderEntityText('text')}
              </div>
            </div>
          </div>
        </div>
        <div className="as-edit-info-div">
          <div className="as-edit-suggestions-heading">
            <span tabIndex={0} aria-label= {experienceTips.writingTipsHeadline}>
               {experienceTips.writingTipsHeadline}
            </span>
          </div>
          <div className="as-edit-card-headline-education">
            {
              <div className="tips-section">
                <div style={{ whiteSpace: 'pre-line' }}>{experienceTips.writingTipsText}</div>
                <div className="tips-heading">{experienceTips.tipsToGetStartedHeadline}</div>
                <div style={{ whiteSpace: 'pre-line' }}>{experienceTips.tipsToGetStartedText}</div>
                {!experienceTips.examples && experienceTips.exampleHeadline ? (
                  <div>
                    <div className="tips-heading">{experienceTips.exampleHeadline}</div>
                    <div style={{ whiteSpace: 'pre-line' }}>{experienceTips.exampleText}</div>
                  </div>
                ) : null}
              </div>
            }
            {experienceTips.examples ? (
              <div className="sample-carousel-wrapper">
                <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === 0} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex - 1 })} className="sample-carousel-btn sample-carousel-btn-prev">
                  <span className="arrow arrow-left" />
                </button>
                <div className="sample-carousel-card">
                  <div className="tips-heading">
                    {'Sample ' + (this.state.iimmumbaiExampleIndex + 1) + ' of ' + experienceTips.examples.length + ' › ' + experienceTips.examples[this.state.iimmumbaiExampleIndex].headline}
                  </div>
                  <div style={{ whiteSpace: 'pre-line' }}>{experienceTips.examples[this.state.iimmumbaiExampleIndex].text}</div>
                </div>
                <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === experienceTips.examples.length - 1} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex + 1 })} className="sample-carousel-btn sample-carousel-btn-next">
                  <span className="arrow arrow-right" />
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const { sectionWiseTextEditable, currentIndex, underlineEntitySpellError } =
      this.props
    underlineEntitySpellError()

    if (
      prevProps.currentIndex !== this.props.currentIndex ||
      JSON.stringify(
        prevProps.sectionWiseTextEditable[prevProps.currentIndex]
      ) !==
        JSON.stringify(
          this.props.sectionWiseTextEditable[this.props.currentIndex]
        )
    ) {
      if (
        !_.isEmpty(
          this.props.sectionWiseTextEditable[this.props.currentIndex]['to']
        ) &&
        this.props.sectionWiseTextEditable[this.props.currentIndex]['to'] ==
          'Present'
      ) {
        this.setState({ checkCurrent: true })
      } else {
        this.setState({ checkCurrent: false })
      }
      this.setInitialState()
    }
  }

  componentDidMount() {}

  componentWillUnmount() {
    const { updateEditDynamicDataState, updateNewSamplesState } = this.props
    updateEditDynamicDataState({
      updateKeys: [
        ['fetchedContent'],
        ['fetchingContent'],
        ['dataContent'],
        ['errorContent'],
        ['fetchedSkills'],
        ['fetchingSkills'],
        ['dataSkills'],
        ['errorSkills'],
        ['fetchedLanguage'],
        ['fetchingLanguage'],
        ['dataLanguage'],
        ['errorLanguage'],
        ['fetchedImpact'],
        ['fetchingImpact'],
        ['dataImpact'],
        ['errorImpact'],
        ['fetchedRephraseWords'],
        ['fetchingRephraseWords'],
        ['dataRephraseWords'],
        ['errorRephraseWords'],
        ['sectionWiseTextIntermediateContent'],
        ['sectionWiseTextIntermediateSkills'],
        ['sectionWiseTextIntermediateImpact'],
        ['sectionWiseTextIntermediateRephraseWords'],
      ],
      data: {
        fetchedContent: false,
        fetchingContent: false,
        dataContent: null,
        errorContent: false,
        fetchedSkills: false,
        fetchingSkills: false,
        dataSkills: null,
        errorSkills: false,
        fetchedLanguage: false,
        fetchingLanguage: false,
        dataLanguage: null,
        errorLanguage: false,
        fetchedImpact: false,
        fetchingImpact: false,
        dataImpact: null,
        errorImpact: false,
        fetchedRephraseWords: false,
        fetchingRephraseWords: false,
        dataRephraseWords: null,
        errorRephraseWords: false,
        sectionWiseTextIntermediateContent: null,
        sectionWiseTextIntermediateSkills: null,
        sectionWiseTextIntermediateImpact: null,
        sectionWiseTextIntermediateRephraseWords: null,
      },
    })
    updateNewSamplesState({
      updateKeys: [['fetched'], ['fetching'], ['samples'], ['error']],
      data: { fetched: false, fetching: false, samples: null, error: false },
    })
    updateResumeGapState({
      updateKeys: [['fetched'], ['fetching'], ['data'], ['error']],
      data: { fetched: false, fetching: false, data: null, error: null },
    })
  }
}

function mapStateToProps(state, ownProps) {
  return {
    savingChanges:
      !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
      ownProps.uploadingEditedData,
    hasResume: state.aspireFeedbackData.has_resume,
    isRightNavToggle: state.editData.isRightNavToggle,
    user: state.user.data,
  }
}

export default connect(mapStateToProps, {
  updateEditDynamicDataState,
  updateNewSamplesState,
  updateResumeGapState,
  fetchResumeGap,
})(injectIntl(Experience))
